function Footer() {
  return (
    <footer
      className='
        relative
        z-20
        px-6
        py-4

        bg-white
        border-t
        border-[#E7E2D9]

        text-center
      '
    >
      {/* subtle gold line */}

      <div
        className='
          absolute
          top-0
          left-0
          w-full
          h-[1px]
          bg-gradient-to-r
          from-transparent
          via-[#C6A75E]/40
          to-transparent
        '
      />

      {/* main brand */}

      <div className='flex flex-col items-center gap-1'>
        <span className='text-[11px] text-[#8A867F]'>
          © 2026 All rights reserved
        </span>
      </div>

      {/* credits */}

      <div
        className='
          mt-2
          text-[10px]
          text-[#A3A09A]
          leading-relaxed
        '
      >
        3D assets: Oversized T-shirt - kylelhb · Simple mug — Dragomike · Coffee
        cup — Sienna Castro · Box model — asads · Tumbler - Snuffkin0405
        (Sketchfab)
      </div>
    </footer>
  );
}

export default Footer;
